<template>
	<div class="con-ball" :style="`width:${size}px;height:${size}px;`">
		<div class="bl" :style="`bottom:${v}%`"></div>
		<div class="bg" :style="`height:${v}%`"></div>
		<span :style="`line-height:${size}px`">{{v}}</span>
	</div>
</template>

<script>
	export default {
		name: "Ball",
		props: {
			size: Number,
			v: Number
		}
	}
</script>

<style scoped lang="less">
	.con-ball {
		border-radius: 50%;
		overflow: hidden;
		border: 2px solid #5B8FF9;
		position: relative;
		text-align: center;

		span {
			font-size: 24px;
			font-weight: bold;
			color: #333333;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}


		.bl {
			width: 100%;
			height: 5px;
			position: absolute;
			left: 0;
			animation: bl 2s linear infinite;
			background-color: rgba(91, 143, 249, 1);
		}

		.bg {
			width: 100%;
			position: absolute;
			left: 0;
			bottom: 0;
			background: #5B8FF9;
		}
	}

	@keyframes bl {
		from {
			background: url("../../assets/img/bl.png") repeat-x 0 0;
		}
		to {
			background: url("../../assets/img/bl.png") repeat-x 100% 0;
		}
	}
</style>
